module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Position-ba391d3af6f203c19ba27818a2a16297.svg";